'use client';

import { c as _c } from "react/compiler-runtime";
import { TipsenLink } from '@svs/nova-poolbetting/ui/TipsenLink';
import Games from '@svs/ui/react/icons/Games';
import Hot from '@svs/ui/react/icons/Hot';
import Results from '@svs/ui/react/icons/Results';
import Tips from '@svs/ui/react/icons/Tips';
import Virtualsports from '@svs/ui/react/icons/Virtualsports';
import { TabsMenu, TabsMenuIcon, TabsMenuItem, TabsMenuLabel } from '@svs/ui/react/tabs-menu';
import { type ComponentType, type ReactNode } from 'react';
import type { IPowerplayModuleConfig } from '@/cms/PowerplayModuleConfig';
import { usePathname } from '@/lib/index.browser';
const iconMap = {
  virtualsports: Virtualsports,
  'nav-games': Games,
  'nav-results': Results,
  hot: Hot,
  tips: Tips
};
function getIconComponent(iconName: string): ComponentType | undefined {
  if (Object.hasOwn(iconMap, iconName)) {
    return iconMap[iconName as keyof typeof iconMap];
  }
  return undefined;
}
type NavigationBarProps = {
  menuItems: IPowerplayModuleConfig['menuItems'];
  initialPathname: string;
  basePath: string;
};

/**
 * Remove base path from URL if it exists.
 *
 * @param url - The URL to process
 * @param basePath - The base path to remove
 * @returns URL without base path
 */
function removeBasePath(url: string, basePath: string): string {
  if (basePath && url.startsWith(basePath)) {
    const result = url.slice(basePath.length);
    return result || '/';
  }
  return url;
}

/**
 * Menu for top navigation.
 *
 * @param root0 props
 * @param root0.menuItems the menu items to render
 * @param root0.initialPathname the initial pathname from server
 * @param root0.basePath the base path of the application
 * @returns menu for top navigation
 */
export default function NavigationBar(t0) {
  const $ = _c(15);
  const {
    menuItems,
    initialPathname,
    basePath
  } = t0;
  const pathname = usePathname();
  let pathnameToUse;
  if ($[0] !== initialPathname || $[1] !== pathname) {
    pathnameToUse = initialPathname;
    if (typeof window !== "undefined") {
      const segments = pathname.split("/").filter(Boolean);
      pathnameToUse = `/${segments[0]}`;
      if (segments.length > 1) {
        pathnameToUse = pathnameToUse + `/${segments[1]}`;
        pathnameToUse;
      }
    }
    $[0] = initialPathname;
    $[1] = pathname;
    $[2] = pathnameToUse;
  } else {
    pathnameToUse = $[2];
  }
  let t1;
  if ($[3] !== menuItems || $[4] !== pathnameToUse) {
    t1 = menuItems.find(item => item.url === pathnameToUse || item.additionalUrls?.some(extraUrl => extraUrl === pathnameToUse)) ?? menuItems[0];
    $[3] = menuItems;
    $[4] = pathnameToUse;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const activeMenuitem = t1;
  const activePathUrl = activeMenuitem?.url;
  let t2;
  if ($[6] !== activePathUrl || $[7] !== basePath || $[8] !== menuItems) {
    let t3;
    if ($[10] !== activePathUrl || $[11] !== basePath) {
      t3 = item_0 => {
        const urlWithoutBasePath = removeBasePath(item_0.url, basePath);
        const isExternalLink = item_0.external;
        const href = {
          pathname: isExternalLink ? item_0.url : urlWithoutBasePath
        };
        const isActive = item_0.url === activePathUrl;
        const {
          icon
        } = item_0.extraConfig;
        const IconComponent = getIconComponent(icon);
        const extraClass = item_0.extraConfig.extraClass || "";
        return <TabsMenuItem aria-label={item_0.alt} key={item_0.label} isActive={isActive} asChild={true}>{isExternalLink ? <a href={href.pathname} className={`grid grid-cols-[auto_1fr] items-center gap-2 ${extraClass}`} rel="noopener noreferrer">{IconComponent && <TabsMenuIcon><IconComponent /></TabsMenuIcon>}<TabsMenuLabel>{item_0.label}</TabsMenuLabel></a> : <TipsenLink href={href} className={`grid grid-cols-[auto_1fr] items-center gap-2 ${extraClass}`}>{IconComponent && <TabsMenuIcon><IconComponent /></TabsMenuIcon>}<TabsMenuLabel>{item_0.label}</TabsMenuLabel></TipsenLink>}</TabsMenuItem>;
      };
      $[10] = activePathUrl;
      $[11] = basePath;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = menuItems.map(t3);
    $[6] = activePathUrl;
    $[7] = basePath;
    $[8] = menuItems;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <TabsMenu className="theme-oddset-vibrant bg-surface-standard" aria-label="Powerplays huvudmeny" size="sm">{t2}</TabsMenu>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}